import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from '../../shared/model';
import { DatabaseConnection } from '../../shared/services/database-connection';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  end_url = 'user'

  constructor(private http : HttpClient, private  dbConnection : DatabaseConnection){}

  getAll(){
    return this.http.get<User[]>(this.dbConnection.remoteApiConnection.value + this.end_url + '/create')
  }

  getSiteUsers(site_id : string){
    return this.http.get<User[]>(this.dbConnection.remoteApiConnection.value + 'site-user/'+site_id)
  }

  create(data : FormData){
    return this.http.post<User>(this.dbConnection.remoteApiConnection.value + this.end_url, data)
  }

  update(data : FormData, id : string){
    return this.http.put<User>(this.dbConnection.remoteApiConnection.value + this.end_url + '/' + id, data)
  }

  delete(id : string){
    return this.http.delete(this.dbConnection.remoteApiConnection.value + this.end_url + '/' + id)
  }

  changeUserStatus(id : string){
    return this.http.get<User>(this.dbConnection.remoteApiConnection.value + this.end_url + '/' + id + '/edit')
  }
}
